var Bootstrap = Esk.Helper.Bootstrap;

var EMAIL_FIELD_ID = "Email",
  EMAIL_FIELD_REF = "Email",
  EMAIL_FIELD_NAME = "email",
  GO_TO_LOGIN_ID = "GoToLogin";

var FORM_REF = "Form";
var Link = ReactRouter.Link;
var RoutePath = Esk.Constants.RoutePath;

var validationRules = require('./validation');

var WithError = require('./../../../utils/mixins/withError');

var ForgotPassword = React.createClass({

  propTypes: {
    onSubmit: React.PropTypes.func
  },

  componentDidMount(){
    var {t} = this.props;
    var form = this.refs[FORM_REF];
    $(form).validate(validationRules(t));
  },

  render(){
    var {t, error} = this.props;
    /*{t("We'll email you with a link to reset your password. Please enter your email address:")}*/
    return (

      <div className="well no-padding">
        <form className="smart-form client-form" ref={FORM_REF}
              onSubmit={this._onSaveHandler}>
          <header>
            {t("Forgot Password")}
          </header>
          <fieldset>

            <Esk.Helper.Ui.ErrorMessage errorMessage={error}/>
            <section>{t("We'll email you with a link to reset your password. Please enter your email address:")}</section>

            <Bootstrap.FormGroupAccount
              elementId={EMAIL_FIELD_ID}
              label={this._getFieldLabel(EMAIL_FIELD_ID)}
            >
              <Esk.Helper.InputTooltip
                icon="fa-envelope"
                helpText={t("Please enter email address for password reset")}
              >
                <input id={EMAIL_FIELD_ID}
                       type="text"
                       className="form-control"
                       ref={EMAIL_FIELD_REF}
                       name={EMAIL_FIELD_NAME}
                       placeholder="Email"
                />
              </Esk.Helper.InputTooltip>
            </Bootstrap.FormGroupAccount>
          </fieldset>

          <Bootstrap.FormActionsAccount>
            <Link to={RoutePath.ROUTE_LOGIN} className="smart-form-link">
              {this._getFieldLabel(GO_TO_LOGIN_ID)}
            </Link>
            <button className="btn btn-primary"
                    type="submit">{t("Send email")}</button>
          </Bootstrap.FormActionsAccount>
        </form>
      </div>
    );
  },

  _getFieldLabel(fieldId){
    var {t} = this.props;
    switch (fieldId) {
      case EMAIL_FIELD_ID:
        return t("Email");
      case GO_TO_LOGIN_ID:
        return t("Go to login");
    }

    return "";
  },

  _onSaveHandler(e){
    e.preventDefault();
    var {onSubmit} = this.props;
    if (!onSubmit) return;

    var form = this.refs[FORM_REF];
    if (!$(form).valid()) return;

    var data = {};
    data.email = this.refs[EMAIL_FIELD_REF].value;
    onSubmit(data);
  }

});

module.exports = WithError(ForgotPassword);
